import { IOrganizationTopShareholder } from 'types/interfaces';

export const topShareholdersMock: IOrganizationTopShareholder[] = [
    {
        address: '0x1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b',
        avatar: 'https://example.com/avatars/1.png',
        daoId: 'dao-001',
        memberBalance: 12500.42,
        name: 'Alice Crypto',
        tokenSharesPercentage: 12.5,
        relativeScore: 'A+',
        absoluteScore: '98/100',
        votesCount: 342,
        proposalsCount: 28,
    },
    {
        address: '0x2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c',
        avatar: null,
        name: 'Bob Blockchain',
        tokenSharesPercentage: 9.8,
        votesCount: 278,
        proposalsCount: 15,
    },
    {
        address: '0x3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d',
        avatar: 'https://example.com/avatars/3.png',
        daoId: 'dao-003',
        memberBalance: 8765.12,
        name: 'Charlie DeFi',
        tokenSharesPercentage: 8.2,
        relativeScore: 'A',
        absoluteScore: '92/100',
        votesCount: 310,
        proposalsCount: 22,
    },
    {
        address: '0x4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e',
        avatar: null,
        name: null,
        tokenSharesPercentage: 7.5,
        votesCount: 195,
        proposalsCount: 8,
    },
    {
        address: '0x5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f',
        avatar: 'https://example.com/avatars/5.png',
        daoId: 'dao-005',
        memberBalance: 6543.21,
        name: 'Eve Ethereum',
        tokenSharesPercentage: 6.8,
        relativeScore: 'A-',
        absoluteScore: '88/100',
        votesCount: 265,
        proposalsCount: 18,
    },
    {
        address: '0x6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5g',
        avatar: null,
        daoId: 'dao-006',
        memberBalance: 5432.1,
        name: 'Frank Finance',
        tokenSharesPercentage: 5.9,
        votesCount: 210,
        proposalsCount: 12,
    },
    {
        address: '0x7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5g6h',
        avatar: 'https://example.com/avatars/7.png',
        name: 'Grace Governance',
        tokenSharesPercentage: 5.2,
        votesCount: 185,
        proposalsCount: 9,
    },
    {
        address: '0x8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5g6h7i',
        avatar: null,
        daoId: 'dao-008',
        memberBalance: 4321.09,
        name: 'Henry Hodler',
        tokenSharesPercentage: 4.7,
        relativeScore: 'B+',
        absoluteScore: '82/100',
        votesCount: 230,
        proposalsCount: 14,
    },
    {
        address: '0x9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5g6h7i8j',
        avatar: 'https://example.com/avatars/9.png',
        name: 'Ivy Investor',
        tokenSharesPercentage: 4.3,
        votesCount: 165,
        proposalsCount: 7,
    },
    {
        address: '0x0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5g6h7i8j9k',
        avatar: null,
        daoId: 'dao-010',
        memberBalance: 3210.98,
        name: 'Jack DAO',
        tokenSharesPercentage: 3.9,
        votesCount: 195,
        proposalsCount: 11,
    },
    {
        address: '0x1e2f3a4b5c6d7e8f9a0b1c2d3e4f5g6h7i8j9k0l',
        avatar: 'https://example.com/avatars/11.png',
        name: 'Karen Keeper',
        tokenSharesPercentage: 3.5,
        relativeScore: 'B',
        absoluteScore: '78/100',
        votesCount: 175,
        proposalsCount: 8,
    },
    {
        address: '0x2f3a4b5c6d7e8f9a0b1c2d3e4f5g6h7i8j9k0l1m',
        avatar: null,
        daoId: 'dao-012',
        memberBalance: 2109.87,
        name: 'Larry Liquidity',
        tokenSharesPercentage: 3.2,
        votesCount: 150,
        proposalsCount: 6,
    },
    {
        address: '0x3a4b5c6d7e8f9a0b1c2d3e4f5g6h7i8j9k0l1m2n',
        avatar: 'https://example.com/avatars/13.png',
        name: 'Molly Mint',
        tokenSharesPercentage: 2.9,
        votesCount: 135,
        proposalsCount: 5,
    },
    {
        address: '0x4b5c6d7e8f9a0b1c2d3e4f5g6h7i8j9k0l1m2n3o',
        avatar: null,
        daoId: 'dao-014',
        memberBalance: 1098.76,
        name: 'Nick Node',
        tokenSharesPercentage: 2.6,
        relativeScore: 'B-',
        absoluteScore: '72/100',
        votesCount: 160,
        proposalsCount: 7,
    },
    {
        address: '0x5c6d7e8f9a0b1c2d3e4f5g6h7i8j9k0l1m2n3o4p',
        avatar: 'https://example.com/avatars/15.png',
        name: 'Olivia Oracle',
        tokenSharesPercentage: 2.3,
        votesCount: 120,
        proposalsCount: 4,
    },
];
